export default __webpack_public_path__ + "static/media/gallery - story - other (1)_04.187c20bb.jpg";